import {
  Checkbox,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import TableSkeleton from "components/skeletons/TableSkeleton";
import TablePagination from "components/tablePagination";
import { useState } from "react";
import CustomerTableRow from "./CustomerTableRow";

const CustomerTable = ({
  allCustomers,
  handleDelete,
  handleEdit,
  handleView,
  setReload,
  pagination,
  setPagination,
  loading,
  handleTableCheckBox,
  selectedRows,
  statuses,
  handleRestore,
  permissions,
}) => {
  const [openNote, setOpenNote] = useState("");
  const rows = allCustomers;
  const columns = [
    { id: "name", label: "Customer Name" },
    { id: "phone", label: "Phone" },
    { id: "followup_date", label: "Followup Date", style: { width: "140px" } },
    { id: "last_note", label: "Last note", style: { width: "190px" } },
    { id: "assignees", label: "Assigned", align: "center" },
    { id: "email", label: "Email" },
    {
      id: "preferred_countries",
      label: "Preferred Countries",
      style: { width: "170px" },
    },
    { id: "source", label: "Source" },
    {
      id: "action",
      label: "Actions",
      style: { width: "150px" },
      align: "center",
    },
  ];

  return (
    <Paper sx={{ width: "100%", overflow: "hidden", boxShadow: "none" }}>
      {!loading ? (
        <TableContainer
          sx={{ height: "calc(100vh - 257px)", overflowX: "auto" }}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow
                sx={{
                  "& .MuiTableCell-sizeMedium": {
                    padding: "10px 0px 10px 16px",
                  },
                  "& .MuiTableCell-sizeMedium:first-of-type": {
                    paddingLeft: "8px",
                    paddingRight: "0px",
                  },
                }}
              >
                <TableCell padding="checkbox">
                  <Checkbox
                    disabled={!permissions["bulk action"]}
                    checked={
                      selectedRows?.length === allCustomers?.length &&
                      allCustomers?.length
                    }
                    onChange={(e) =>
                      handleTableCheckBox("all", e.target.checked)
                    }
                  />
                </TableCell>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={column.style}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows?.map((row) => (
                <CustomerTableRow
                  key={row.id}
                  row={row}
                  columns={columns}
                  span={columns?.length}
                  handleDelete={handleDelete}
                  handleEdit={handleEdit}
                  handleView={handleView}
                  setReload={setReload}
                  setOpenNote={setOpenNote}
                  openNote={openNote}
                  handleTableCheckBox={handleTableCheckBox}
                  selectedRows={selectedRows}
                  statuses={statuses}
                  handleRestore={handleRestore}
                  permissions={permissions}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <TableSkeleton columns={columns} tableHeight="calc(100vh - 257px)" />
      )}
      <TablePagination
        span={columns?.length}
        setReload={setReload}
        pagination={pagination}
        setPagination={setPagination}
      />
    </Paper>
  );
};

export default CustomerTable;
